// ─────────────────────────────────────────────────────────────────────
// AN ERASED PLAYER HAS NO NAME, AND THE SCREEN SAYS SO (#1062).
//
// When a person erases their data (`POST /me/erase`), their player row stays —
// results and ratings other players' numbers were computed from point at it
// (PERSONAL_DATA.md § 5.3) — but its name is emptied, and the database keeps it
// empty (`players_erased_stays_anonymous`). The API marks such a player
// `erased: true` (`apps/api/src/lib/playerRow.ts`).
//
// A blank where a name should be reads as a bug. So every place a player's name
// is shown asks this for it, and an erased player reads «Slettet spiller» /
// «Deleted player» — a LABEL chosen in the browser, in the reader's language,
// never a translated string stored as data (CLAUDE.md, #310a).
// ─────────────────────────────────────────────────────────────────────

/** The API's projection of `players.erased_at`. */
export function isErasedPlayer(player: unknown): boolean {
  return (player as { erased?: unknown } | null | undefined)?.erased === true;
}

/**
 * The name to SHOW for a player: their name, or the neutral label when their
 * person erased it. Display only — never a key, never stored, never compared.
 */
export function playerDisplayName(
  player: { name?: unknown } | null | undefined,
  erasedLabel: string,
): string {
  if (isErasedPlayer(player)) return erasedLabel;
  return typeof player?.name === 'string' ? player.name : String(player?.name ?? '');
}
